import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'
import {states} from "../data/BusinessType"

const BusinessAdminRegistration = () => {
        const [businessRegistrationData, setBusinessRegistrationData] = useState({
            name: "",
            ic: "",
            dic: "",
            email: "",
            password: "",
            language: "cs",
            street: "",
            city: "",
            postalCode: "",
            country: "Česko",
            termsAndConditions: false,
        })
        const [message, setMessage] = useState(null)
        const navigate = useNavigate()
        const DataChange = (e) => {
            const {name, value, type, checked} = e.target
            setBusinessRegistrationData((prevData) => ({
                ...prevData,
                [name]: type === "checkbox" ? checked : value,
            }))
        }
        const formSubmit = async (e) => {
            e.preventDefault()
            try {
                console.log(businessRegistrationData)
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/business/multiple-business-register`, businessRegistrationData)
                setMessage(response?.data.message || "Registrace proběhla úspěšně")
                navigate("/business/profile")
            } catch (err) {
                setMessage(err.response?.data || "Něco se pokazilo")
            } finally {
                setTimeout(() => {
                    setMessage(null)
                    navigate("/business/profile")
                }, 2000)
            }
        }
  return (
    <div>
        <div>
        <h2 className="services-title">Registrace podniku s více profily</h2>
        <form className="login-form" onSubmit={formSubmit}>
            <input
                type="text"
                placeholder="Jméno a přijmení"
                name="name"
                value={businessRegistrationData.name}
                onChange={DataChange}
                required
                className="login-input registration-input-width"
            />   

            <input
                type="text"
                placeholder="IČ (nepovinné)"
                name="ic"
                value={businessRegistrationData.ic}
                onChange={DataChange}
                className="login-input registration-input-width"
            />
            <input
                type="text"
                placeholder="DIČ (nepovinné)"
                name="dic"
                value={businessRegistrationData.dic}
                onChange={DataChange}
                className="login-input registration-input-width"
            />
            <input
                type="email"
                placeholder="Email"
                name="email"
                value={businessRegistrationData.email}
                onChange={DataChange}
                required
                className="login-input registration-input-width"
            />
            <input
                type="password"
                placeholder="Heslo"
                name="password"
                value={businessRegistrationData.password}
                onChange={DataChange}
                required
                className="login-input registration-input-width"
            />
             <input
                type="text"
                placeholder="Město"
                name="city"
                value={businessRegistrationData.city}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />
                        <input
                type="text"
                placeholder="Ulice"
                name="street"
                value={businessRegistrationData.street}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />
             <input
                type="text"
                placeholder="Číslo popisné"
                name="houseNumber"
                value={businessRegistrationData.houseNumber}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />
              <input
                type="text"
                placeholder="PSČ"
                name="postalCode"
                value={businessRegistrationData.postalCode}
                onChange={DataChange} // Používáme AddressChange
                required
                className="login-input registration-input-width"
            />
                        <select

                            name="country"
                            value={businessRegistrationData.country}
                            onChange={DataChange}
                            required
                            className="login-input registration-input-width"
                        >
                            {states.map((state, index) => (
                                <option key={index} value={state.name}>
                                    {state.name}
                                </option>
                            ))}
                        </select>

            <div className='gdpr'>
        <p >Souhlasím s podmínky používání</p>
      <input 
        type='checkbox'
        name='termsAndConditions'
        value={businessRegistrationData.termsAndConditions}
        onChange={DataChange}
        required
      />
      </div>
            <button type="submit" className="login-button">
                Registrovat se
            </button>
        </form>
        <div className="login-links">
            <Link to="/termsAndConditions" className="login-link">Podmínky používání a cookies</Link>
            <Link to="/termsAndConditions" className="login-link">Zásady ochrany osobních údajů</Link>
    
        </div>
    {message && <p className="message">{message}</p>}
    </div>
    </div>
  )
}

export default BusinessAdminRegistration